import { useEffect } from "react";
import { toast } from "react-toastify";

/**
 * Hook para manejar mensajes persistentes entre navegaciones
 * Útil para mostrar notificaciones después de redirecciones
 */
export const useSessionMessage = () => {
    useEffect(() => {
        // Verificar si hay un mensaje pendiente en sessionStorage
        const mensaje = sessionStorage.getItem('mensaje_pendiente');
        const tipoMensaje = sessionStorage.getItem('tipo_mensaje');
        
        if (mensaje) {
            // Pequeño delay para asegurar que el DOM esté listo
            const timer = setTimeout(() => {
                switch (tipoMensaje) {
                    case 'success':
                        toast.success(mensaje, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            position: 'top-center'
                        });
                        break;
                    case 'error':
                        toast.error(mensaje, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            position: 'top-center'
                        });
                        break;
                    case 'warning':
                        toast.warning(mensaje, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            position: 'top-center'
                        });
                        break;
                    case 'info':
                        toast.info(mensaje, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            position: 'top-center'
                        });
                        break;
                    default:
                        toast(mensaje, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            position: 'top-center'
                        });
                }
                
                // Limpiar el mensaje después de mostrarlo
                sessionStorage.removeItem('mensaje_pendiente');
                sessionStorage.removeItem('tipo_mensaje');
            }, 200);

            return () => clearTimeout(timer);
        }
    }, []);
};

/**
 * Función helper para establecer un mensaje que se mostrará en el próximo componente
 * @param {string} mensaje - El mensaje a mostrar
 * @param {string} tipo - Tipo de mensaje: 'success' | 'error' | 'warning' | 'info'
 */
export const setSessionMessage = (mensaje, tipo = 'success') => {
    sessionStorage.setItem('mensaje_pendiente', mensaje);
    sessionStorage.setItem('tipo_mensaje', tipo);
};